/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/ja';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "きれいなpretty HTMLエディタにアクセス"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "アクセシビリティチェッカー"
  },
  "action_to_take_b626a99a": {
    "message": "実行するアクション："
  },
  "add_8523c19b": {
    "message": "追加"
  },
  "add_a_caption_2a915239": {
    "message": "キャプションを追加"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "画像の代替テキストを追加する"
  },
  "add_another_f4e50d57": {
    "message": "もう 1 つ追加"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "CC /字幕を追加"
  },
  "add_image_60b2de07": {
    "message": "画像を追加"
  },
  "add_one_9e34a6f8": {
    "message": "1 ページ追加"
  },
  "additional_considerations_f3801683": {
    "message": "さらなる考慮事項"
  },
  "address_applied_64269b0b": {
    "message": "アドレスを適用した"
  },
  "address_removed_fcb496e0": {
    "message": "アドレスを削除した"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "同じURLを持つ隣接リンクは1つのリンクでなければなりません。"
  },
  "aleph_f4ffd155": {
    "message": "アレフ"
  },
  "align_11050992": {
    "message": "位置調整"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "配置とリスト"
  },
  "all_4321c3a1": {
    "message": "すべて"
  },
  "all_apps_a50dea49": {
    "message": "すべてのアプリ"
  },
  "allow_media_download_16dcf2bd": {
    "message": "メディアのダウンロードを許可する"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "成績証明書のダウンロードを許可する"
  },
  "alpha_15d59033": {
    "message": "アルファ"
  },
  "alphabetical_55b5b4e0": {
    "message": "名前順"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "代替属性テキストは120文字を超えてはなりません。"
  },
  "alt_text_611fb322": {
    "message": "Alt テキスト"
  },
  "amalg_coproduct_c589fb12": {
    "message": "アマルグ（共製品）"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "ファイルを読み取る際にエラーが発生しました"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "ネットワーク要求の作成中にエラーが発生しました"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "あなたのメディアをアップロードする際にエラーが発生しました。"
  },
  "and_7fcc2911": {
    "message": "および"
  },
  "angle_c5b4ec50": {
    "message": "角度"
  },
  "announcement_fb4cb645": {
    "message": "発表"
  },
  "announcement_list_da155734": {
    "message": "アナウンス リスト"
  },
  "announcements_a4b8ed4a": {
    "message": "発表"
  },
  "apply_781a2546": {
    "message": "適用"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "コース内のこのアイコンメーカーのアイコンのすべてのインスタンスに変更を適用する"
  },
  "approaches_the_limit_893aeec9": {
    "message": "限界に近づく"
  },
  "approximately_e7965800": {
    "message": "だいたい"
  },
  "apps_54d24a47": {
    "message": "アプリ"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "ほんとうにキャンセルしますか?行われた変更は保存されません。"
  },
  "arrows_464a3e54": {
    "message": "矢印"
  },
  "art_icon_8e1daad": {
    "message": "アートのアイコン"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "アスペクト比は維持されます"
  },
  "assignment_976578a8": {
    "message": "課題"
  },
  "assignments_1e02582c": {
    "message": "課題"
  },
  "asterisk_82255584": {
    "message": "アスタリスク"
  },
  "attributes_963ba262": {
    "message": "属性"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "音声および動画の記録はサポートされていません。他のブラウザを使用してください。"
  },
  "audio_options_feb58e2c": {
    "message": "オーディオオプション"
  },
  "audio_options_tray_33a90711": {
    "message": "オーディオオプショントレイ"
  },
  "audio_player_for_title_20cc70d": {
    "message": "{ title }のオーディオプレーヤー"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "自動保存されたコンテンツが存在します。自動保存されたコンテンツを代わりにロードしますか？"
  },
  "available_folders_694d0436": {
    "message": "使用可能なフォルダ"
  },
  "background_1bc88842": {
    "message": "背景"
  },
  "backslash_b2d5442d": {
    "message": "バックスラッシュ"
  },
  "bar_ec63ed6": {
    "message": "バー"
  },
  "basic_554cdc0a": {
    "message": "ベーシック"
  },
  "because_501841b": {
    "message": "理由は"
  },
  "below_81d4dceb": {
    "message": "下の"
  },
  "beta_cb5f307e": {
    "message": "バータ"
  },
  "big_circle_16b2e604": {
    "message": "大きな丸"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "二項係数"
  },
  "black_4cb01371": {
    "message": "黒"
  },
  "blue_daf8fea9": {
    "message": "ブルー"
  },
  "bold_applied_42d547b7": {
    "message": "太字を適用した"
  },
  "bold_removed_da474a5c": {
    "message": "太字を削除した"
  },
  "border_5b08b06d": {
    "message": "ボーダー"
  },
  "bottom_15a2a9be": {
    "message": "下"
  },
  "bottom_third_5f5fec1d": {
    "message": "下から3番目"
  },
  "bowtie_5f9629e4": {
    "message": "ボウタイ"
  },
  "brick_f2656265": {
    "message": "ブロック"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "キャンセル"
  },
  "cap_product_3a5265a6": {
    "message": "キャップ製品"
  },
  "caption_manager_aae0906f": {
    "message": "キャプションマネージャ"
  },
  "center_align_e68d9997": {
    "message": "センターアライン"
  },
  "centered_dot_64d5e378": {
    "message": "中央の点"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "中央の水平ドット"
  },
  "change_alt_text_92654906": {
    "message": "代替テキストを変更"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "見出しタグを段落に変更する"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "ヘッダーのレベルのみ変更する"
  },
  "change_text_color_1aecb912": {
    "message": "テキストの色を変更する"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "変更は、このページを保存した後に適用されます。"
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "行われた変更は保存されません。"
  },
  "characters_9d897d1c": {
    "message": "文字"
  },
  "characters_no_spaces_485e5367": {
    "message": "文字（スペースなしで）"
  },
  "check_accessibility_3c78211c": {
    "message": "アクセシビリティをチェックする"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "アクセシビリティ問題をチェック"
  },
  "chi_54a32644": {
    "message": "チ"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "キャプションファイルを選択する"
  },
  "choose_usage_rights_33683854": {
    "message": "使用権を選択..."
  },
  "circle_484abe63": {
    "message": "円"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "丸い番号無しリスト"
  },
  "clear_2084585f": {
    "message": "クリア"
  },
  "clear_image_3213fe62": {
    "message": "画像を消す"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "クリックまたはシフトクリックでHTMLエディタに移動します。"
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "クリックして{ imageName }を埋め込みます"
  },
  "click_to_hide_preview_3c707763": {
    "message": "クリックしてプレビューを非表示にする"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "クリックすると、エディタにリンクが挿入されます。"
  },
  "click_to_show_preview_faa27051": {
    "message": "クリックしてプレビューを表示する"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "メニューまたはダイアログを閉じます。またエディタエリアに戻ります"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "アクセシビリティチェッカーを閉じる"
  },
  "close_d634289d": {
    "message": "閉じる"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "キーボードショートカットモダルを閉じる"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "クローズドキャプションファイルは { maxKb } kb未満であること"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "クローズドキャプション/字幕"
  },
  "clubs_suit_c1ffedff": {
    "message": "クラブ(1組)"
  },
  "collab_575ac7bc": {
    "message": "コラボ"
  },
  "collaborations_5c56c15f": {
    "message": "コラボレーション"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "{ types } を非表示にするには破損する"
  },
  "color_a363e1b0": {
    "message": "カラー"
  },
  "color_contrast_4c418add": {
    "message": "色のコントラスト"
  },
  "color_contrast_ratio_687782f0": {
    "message": "色のコントラスト比"
  },
  "color_picker_6b359edf": {
    "message": "色を選択"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "色を選択（{ colorName }が現在選択されている）"
  },
  "color_popup_af39810f": {
    "message": "色のポップアップ"
  },
  "column_e1ae5c64": {
    "message": "列"
  },
  "column_group_1c062368": {
    "message": "列グループ"
  },
  "complex_numbers_a543d004": {
    "message": "複素数"
  },
  "computer_1d7dfa6f": {
    "message": "コンピュータ"
  },
  "congruent_5a244acd": {
    "message": "合同"
  },
  "contains_311f37b7": {
    "message": "含有"
  },
  "content_1440204b": {
    "message": "コンテンツ"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "エディタ内のコンテンツは変更されます。「キャンセル」を押すとオリジナルのコンテンツが保持されます。"
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "コンテンツはまだアップロード中です。続行すると適切に埋め込まれません。"
  },
  "content_subtype_5ce35e88": {
    "message": "コンテンツのサブタイプ"
  },
  "content_type_2cf90d95": {
    "message": "コンテンツ タイプ"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "YouTubeのコンテンツを続ける"
  },
  "coproduct_e7838082": {
    "message": "共製品"
  },
  "copyright_holder_66ee111": {
    "message": "著作権保有者:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "コンテンツを挿入できません：\"{ itemType }\" アイテムは、現在Canvasにサポートされていません。"
  },
  "count_40eced3b": {
    "message": "数"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 語}\n    one {1 語}\n  other {# 語}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# アイテムを読込みました}\n  other {# アイテムを読込みました}\n}"
  },
  "course_documents_104d76e0": {
    "message": "コースドキュメント"
  },
  "course_files_62deb8f8": {
    "message": "コースファイル"
  },
  "course_files_a31f97fc": {
    "message": "コース ファイル"
  },
  "course_images_f8511d04": {
    "message": "コース画像"
  },
  "course_link_b369426": {
    "message": "コースリンク"
  },
  "course_links_b56959b9": {
    "message": "コースリンク"
  },
  "course_media_ec759ad": {
    "message": "コースメディア"
  },
  "course_navigation_dd035109": {
    "message": "コース ナビゲーション"
  },
  "create_icon_110d6463": {
    "message": "アイコンを作成する"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "アイコンメーカーのアイコンを作成する"
  },
  "creative_commons_license_725584ae": {
    "message": "クリエイティブ コモンズ ライセンス:"
  },
  "crop_image_41bf940c": {
    "message": "画像を切り取る"
  },
  "crop_image_807ebb08": {
    "message": "画像の切り取り"
  },
  "cup_product_14174434": {
    "message": "カップ製品"
  },
  "current_image_f16c249c": {
    "message": "現在の画像"
  },
  "current_link_945a47ee": {
    "message": "現在のリンク"
  },
  "current_volume_level_c55ab825": {
    "message": "現在の音量のレベル"
  },
  "custom_6979cd81": {
    "message": "カスタム"
  },
  "cyan_c1d5f68a": {
    "message": "シアン"
  },
  "dagger_57e0f4e5": {
    "message": "短剣"
  },
  "date_added_ed5ad465": {
    "message": "追加された日付順"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "装飾アイコン"
  },
  "decorative_image_fde98579": {
    "message": "飾りの画像"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "装飾的{ TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "インデントを減らす"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "リッチコンテンツ領域の高さを縮小する"
  },
  "deep_purple_bb3e2907": {
    "message": "ディープパープル"
  },
  "default_9db103d": {
    "message": "デフォルト"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "デフォルトの箇条書きの番号無しリスト"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "デフォルトの番号順リスト"
  },
  "definite_integral_fe7ffed1": {
    "message": "定積分"
  },
  "degree_symbol_4a823d5f": {
    "message": "度数記号"
  },
  "delimiters_4db4840d": {
    "message": "デリミタ"
  },
  "delta_53765780": {
    "message": "デルタ"
  },
  "describe_the_icon_f6a18823": {
    "message": "(アイコンの説明)"
  },
  "describe_the_type_ff448da5": {
    "message": "({ TYPE }を説明する)"
  },
  "description_436c48d7": {
    "message": "説明"
  },
  "details_98a31b68": {
    "message": "詳細"
  },
  "diagonal_dots_7d71b57e": {
    "message": "対角線上の点"
  },
  "diamond_b8dfe7ae": {
    "message": "ダイヤモンド"
  },
  "diamonds_suit_526abaaf": {
    "message": "ダイヤ(1組)"
  },
  "digamma_258ade94": {
    "message": "ディガンマ"
  },
  "dimension_type_f5fa9170": {
    "message": "サイズタイプ"
  },
  "directionality_26ae9e08": {
    "message": "方向性"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "ディレクトリ編集 LaTeX"
  },
  "disable_preview_222bdf72": {
    "message": "プレビューを無効にする"
  },
  "discussion_6719c51d": {
    "message": "ディスカッション"
  },
  "discussions_a5f96392": {
    "message": "ディスカッション"
  },
  "discussions_index_6c36ced": {
    "message": "ディスカッションのインデックス"
  },
  "disjoint_union_e74351a8": {
    "message": "不連続ユニオン"
  },
  "display_options_315aba85": {
    "message": "オプションを表示する"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "テキストリンクを表示する (新しいタブが開きます)"
  },
  "div_applied_49ad83fc": {
    "message": "Divを適用した"
  },
  "div_removed_d13f8e17": {
    "message": "Divを削除した"
  },
  "division_sign_72190870": {
    "message": "分割サイン"
  },
  "document_678cd7bf": {
    "message": "ドキュメント"
  },
  "documents_81393201": {
    "message": "ドキュメント"
  },
  "done_54e3d4b6": {
    "message": "完了"
  },
  "double_dagger_faf78681": {
    "message": "ダブルの短剣"
  },
  "down_5831a426": {
    "message": "下"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "下・左の対角線矢印"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "下・右の対角線矢印"
  },
  "download_filename_2baae924": {
    "message": "{ filename }をダウンロードする"
  },
  "downward_arrow_cca52012": {
    "message": "下向きの矢印"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "逆三角形"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "ファイルをここにドラッグする"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "ドラッグアンドドロップまたはクリックしてコンピュータを参照"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "ハンドルをドラッグします。上下矢印を使用してサイズを変更する"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "期限：複数の日付"
  },
  "due_when_7eed10c6": {
    "message": "期限：{ when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "このアイコンインスタンスのaltテキストを編集する"
  },
  "edit_c5fbea07": {
    "message": "編集"
  },
  "edit_course_link_5a5c3c59": {
    "message": "コースリンクを編集"
  },
  "edit_equation_f5279959": {
    "message": "方程式を編集する"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "既存のアイコンメーカーのアイコンを編集する"
  },
  "edit_icon_2c6b0e91": {
    "message": "アイコンを編集する"
  },
  "edit_link_7f53bebb": {
    "message": "リンクの編集"
  },
  "editor_status_bar_653f44ee": {
    "message": "エディターステータスバー"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "{ start } で始まる要素"
  },
  "embed_828fac4a": {
    "message": "埋め込み"
  },
  "embed_code_314f1bd5": {
    "message": "埋め込みコード"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "外部ツールからの埋込コンテンツ"
  },
  "embed_image_1080badc": {
    "message": "画像の埋め込み"
  },
  "embed_video_a97a64af": {
    "message": "ビデオを埋め込む"
  },
  "embedded_content_aaeb4d3d": {
    "message": "埋め込まれたコンテンツ"
  },
  "empty_set_91a92df4": {
    "message": "空のセット"
  },
  "encircled_dot_8f5e51c": {
    "message": "囲みドット"
  },
  "encircled_minus_72745096": {
    "message": "囲みマイナス"
  },
  "encircled_plus_36d8d104": {
    "message": "囲みプラス"
  },
  "encircled_times_5700096d": {
    "message": "囲みの時代"
  },
  "engineering_icon_f8f3cf43": {
    "message": "エンジニアリングのアイコン"
  },
  "english_icon_25bfe845": {
    "message": "英語のアイコン"
  },
  "enter_a_media_title_81b490ec": {
    "message": "メディアタイトルを入力"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "検索する語を3文字以上入力してください"
  },
  "enter_replacement_text_17631bbc": {
    "message": "代替テキストを入力する"
  },
  "enter_search_text_26cb4459": {
    "message": "検索テキストを入力する"
  },
  "epsilon_54bb8afa": {
    "message": "エプシロン"
  },
  "epsilon_variant_d31f1e77": {
    "message": "イプシロン(変形)"
  },
  "equals_sign_c51bdc58": {
    "message": "等記号"
  },
  "equation_1c5ac93c": {
    "message": "方程式"
  },
  "equation_editor_39fbc3f1": {
    "message": "方程式エディタ"
  },
  "equilibrium_6ff3040b": {
    "message": "均衡"
  },
  "equivalence_class_7b0f11c0": {
    "message": "等価クラス"
  },
  "equivalent_identity_654b3ce5": {
    "message": "等価 (同一性)"
  },
  "eta_b8828f99": {
    "message": "イータ"
  },
  "exists_2e62bdaa": {
    "message": "存在する"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "全画面表示終了"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "デフォルトによるプレビューの拡大"
  },
  "expand_to_see_types_f5d29352": {
    "message": "{ types } を拡張して表示"
  },
  "external_link_d3f9e62a": {
    "message": "外部リンク"
  },
  "external_tool_frame_70b32473": {
    "message": "外部ツールフレーム"
  },
  "external_tools_6e77821": {
    "message": "外部ツール"
  },
  "extra_large_b6cdf1ff": {
    "message": "特大"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "特大 ({ width } x { height }px)"
  },
  "extra_small_9ae33252": {
    "message": "超小型"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "課外活動のアイコン"
  },
  "f_function_fe422d65": {
    "message": "F (関数)"
  },
  "fail_544e5dde": {
    "message": "不合格"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "ファイルのコンテンツ取得に失敗しました"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "外部ツールからのコンテンツ取得に失敗しました"
  },
  "file_name_8fd421ff": {
    "message": "ファイル名"
  },
  "file_preview_21667a6e": {
    "message": "ファイルプレビュー"
  },
  "file_preview_for_filename_ab314195": {
    "message": "{ fileName }用のファイルプレビュー"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "ファイル保存のサイズを超過"
  },
  "file_url_c12b64be": {
    "message": "ファイル URL"
  },
  "filename_file_icon_602eb5de": {
    "message": "{ filename } ファイルアイコン"
  },
  "filename_image_preview_6cef8f26": {
    "message": "{ filename } 画像プレビュー"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "{ filename } テキストプレビュー"
  },
  "files_c300e900": {
    "message": "ファイル"
  },
  "files_index_af7c662b": {
    "message": "ファイルのインデックス"
  },
  "find_8d605019": {
    "message": "検索"
  },
  "find_and_replace_6e345933": {
    "message": "検索して置換"
  },
  "finish_bc343002": {
    "message": "完了"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "見出しヒエアルキーを修正する"
  },
  "flat_music_76d5a5c3": {
    "message": "フラット(音楽)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "フォーカス要素オプションツールバー"
  },
  "folder_tree_fbab0726": {
    "message": "フォルダツリー"
  },
  "for_all_b919f972": {
    "message": "全員に"
  },
  "format_4247a9c5": {
    "message": "形式"
  },
  "format_as_a_list_142210c3": {
    "message": "リスト形式"
  },
  "formatting_5b143aa8": {
    "message": "フォーマット"
  },
  "forward_slash_3f90f35e": {
    "message": "前向きのスラッシュ"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "自動保存されたコンテンツが見つかりました"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "{ count, plural,\n     =0 {# 結果}\n    one {# 1つの結果}\n  other {# 結果}\n}が見つかりました"
  },
  "fraction_41bac7af": {
    "message": "分数・分画"
  },
  "fullscreen_873bf53f": {
    "message": "全画面"
  },
  "gamma_1767928": {
    "message": "ガンマ"
  },
  "generating_preview_45b53be0": {
    "message": "プレビュー中..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "{ size }KBを超えるGIF/PNG形式の画像は現在サポートされていません。"
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "エディタのメニューバーに移動する"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "エディタのツールバーに移動する"
  },
  "grades_a61eba0a": {
    "message": "評定"
  },
  "graphics_text_bc9568bc": {
    "message": "グラフィックテキスト"
  },
  "greater_than_e98af662": {
    "message": "＞"
  },
  "greater_than_or_equal_b911949a": {
    "message": "≧"
  },
  "greek_65c5b3f7": {
    "message": "ギリシャ文字"
  },
  "green_15af4778": {
    "message": "グリーン"
  },
  "grey_a55dceff": {
    "message": "グレー"
  },
  "group_documents_8bfd6ae6": {
    "message": "グループドキュメント"
  },
  "group_files_4324f3df": {
    "message": "グループファイル"
  },
  "group_files_82e5dcdb": {
    "message": "グループ ファイル"
  },
  "group_images_98e0ac17": {
    "message": "グループ画像"
  },
  "group_isomorphism_45b1458c": {
    "message": "グループ同型"
  },
  "group_link_63e626b3": {
    "message": "グループリンク"
  },
  "group_links_9493129e": {
    "message": "グループリンク"
  },
  "group_media_2f3d128a": {
    "message": "グループメディア"
  },
  "group_navigation_99f191a": {
    "message": "グループ ナビゲーション"
  },
  "h_bar_bb94deae": {
    "message": "Hバー"
  },
  "hat_ea321e35": {
    "message": "帽子"
  },
  "header_column_f27433cb": {
    "message": "ヘッダー列"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "ヘッダーの行と列"
  },
  "header_row_f33eb169": {
    "message": "ヘッダー行"
  },
  "heading_2_5b84eed2": {
    "message": "見出し2"
  },
  "heading_3_2c83de44": {
    "message": "見出し3"
  },
  "heading_4_b2e74be7": {
    "message": "見出し4"
  },
  "heading_h_applied_eccd294d": {
    "message": "{ h }見出しを適用した"
  },
  "heading_h_removed_745f24a6": {
    "message": "{ h }見出しを削除した"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "見出しレベルはスキップしないでください。"
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "{ start } で始まる見出し"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "見出しテキストは120文字を超えてはなりません。"
  },
  "health_icon_8d292eb5": {
    "message": "健康のアイコン"
  },
  "hearts_suit_e50e04ca": {
    "message": "ハート（1組）"
  },
  "height_69b03e15": {
    "message": "高さ"
  },
  "hexagon_d8468e0d": {
    "message": "六角形"
  },
  "hide_description_bfb5502e": {
    "message": "説明を非表示にする"
  },
  "hide_title_description_caf092ef": {
    "message": "{ title }説明を非表示にする"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "エレメントをハイライトして、エレメントオプションツールバーを起動する"
  },
  "home_351838cd": {
    "message": "ホーム"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "キャプションを要求し編集する方法は？"
  },
  "html_code_editor_fd967a44": {
    "message": "Html コードエディタ"
  },
  "html_editor_fb2ab713": {
    "message": "HTML エディタ"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "このファイルを使用する権限を取得しています。"
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "著作権を保有しています"
  },
  "icon_215a1dc6": {
    "message": "アイコン"
  },
  "icon_8168b2f8": {
    "message": "アイコン"
  },
  "icon_color_b86dd6d6": {
    "message": "アイコンカラー"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "アイコンメーカーのアイコン"
  },
  "icon_options_7e32746e": {
    "message": "アイコンオプション"
  },
  "icon_options_tray_2b407977": {
    "message": "アイコンオプショントレイ"
  },
  "icon_preview_1782a1d9": {
    "message": "アイコンプレビュー"
  },
  "icon_shape_30b61e7": {
    "message": "アイコンの形状"
  },
  "icon_size_9353edea": {
    "message": "アイコンのサイズ"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "空欄の場合、リンクテキストはコースリンク名として表示されます。"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "利用権が必要な場合は、「ファイル」ページで利用権を有効にするまでファイルは公開されません。"
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "今すぐ使用権を選択しないと、このファイルはアップロード後に公開されません。"
  },
  "image_8ad06": {
    "message": "画像"
  },
  "image_c1c98202": {
    "message": "画像"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "画像ファイル名を、画像の代替テキストとして使用しないでください。"
  },
  "image_options_5412d02c": {
    "message": "画像オプション"
  },
  "image_options_tray_90a46006": {
    "message": "画像オプショントレイ"
  },
  "image_to_crop_3a34487d": {
    "message": "クロップする画像"
  },
  "image_with_filename_file_aacd7180": {
    "message": "ファイル名 { file } の画像"
  },
  "images_7ce26570": {
    "message": "画像"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "画像には、画像の内容を記述する alt 属性が含まれていなければなりません。"
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "複素数の虚数部分"
  },
  "in_element_of_19ca2f33": {
    "message": "（）内（の要素）"
  },
  "increase_indent_6af90f7c": {
    "message": "インデントを増やす"
  },
  "increase_rich_content_area_340b775": {
    "message": "リッチコンテンツ領域の高さを拡大する"
  },
  "indefinite_integral_6623307e": {
    "message": "不定積分"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } / { max }"
  },
  "indigo_2035fc55": {
    "message": "インディゴ"
  },
  "inference_fed5c960": {
    "message": "推論"
  },
  "infinity_7a10f206": {
    "message": "無限"
  },
  "input_field_for_alpha_678265fd": {
    "message": "アルファ入力欄"
  },
  "input_field_for_blue_561e020a": {
    "message": "青の入力欄"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "緑色の入力欄"
  },
  "input_field_for_red_86a84615": {
    "message": "赤の入力欄"
  },
  "insert_593145ef": {
    "message": "挿入"
  },
  "insert_link_6dc23cae": {
    "message": "リンクの挿入"
  },
  "insert_math_equation_57c6e767": {
    "message": "数学数式を挿入"
  },
  "integers_336344e1": {
    "message": "整数"
  },
  "intersection_cd4590e4": {
    "message": "交差点"
  },
  "invalid_description_991e23bb": {
    "message": "無効な記述"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "無効な入力。"
  },
  "invalid_file_c11ba11": {
    "message": "無効なファイル"
  },
  "invalid_file_type_881cc9b2": {
    "message": "無効なファイル タイプです"
  },
  "invalid_url_cbde79f": {
    "message": "無効な URL"
  },
  "iota_11c932a9": {
    "message": "イオタ"
  },
  "issue_num_total_f94536cf": {
    "message": "問題 { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "イタリックを適用した"
  },
  "italic_removed_17cbab6f": {
    "message": "イタリックを削除した"
  },
  "kappa_2f14c816": {
    "message": "カッパ"
  },
  "kappa_variant_eb64574b": {
    "message": "カッパ (変種)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "キーボード ショートカット"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "キーボードは Tab キーを使用してリンクにナビゲートします。同じ宛先に向かう2つの隣接リンクがあると、キーボードユーザーに混乱を招く可能性があります。"
  },
  "lambda_4f602498": {
    "message": "ラムダ"
  },
  "language_arts_icon_a798b0f8": {
    "message": "語学のアイコン"
  },
  "languages_icon_9d20539": {
    "message": "言語のアイコン"
  },
  "large_9c5e80e7": {
    "message": "大"
  },
  "large_text_e7ba08cd": {
    "message": "大きな文字"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "大 ({ width } x { height }px)"
  },
  "learn_ad3b3505": {
    "message": "学習する"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "隣接リンクの詳細"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "カラーコントラストの詳細"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "ページヘッダーの整理の詳細"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "適切なページヘッダー構成についての詳細"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "表ヘッダーの詳細"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "代替テキストを画像に使用する方法の詳細"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "表でキャプションを使用する方法の詳細"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "ファイル名を代替テキストに使用する方法の詳細"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "リスト使用の詳細"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "表でスコープ属性を使用する方法の詳細"
  },
  "leave_as_is_4facfe55": {
    "message": "そのままにする"
  },
  "left_3ea9d375": {
    "message": "左"
  },
  "left_align_43d95491": {
    "message": "左揃え"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "左傾きブラケット"
  },
  "left_arrow_4fde1a64": {
    "message": "左の矢印"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "左矢印フック付き"
  },
  "left_ceiling_ee9dd88a": {
    "message": "左シーリング"
  },
  "left_curly_brace_1726fb4": {
    "message": "左波括弧"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "左下向き銛型矢印"
  },
  "left_floor_29ac2274": {
    "message": "左床"
  },
  "left_to_right_e9b4fd06": {
    "message": "左から右"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "左下向き銛型矢印"
  },
  "leftward_arrow_1e4765de": {
    "message": "左向き矢印"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "左が尖った三角形"
  },
  "less_than_a26c0641": {
    "message": "＜"
  },
  "less_than_or_equal_be5216cb": {
    "message": "≦"
  },
  "library_icon_ae1e54cf": {
    "message": "ライブラリーのアイコン"
  },
  "light_blue_5374f600": {
    "message": "ライトブルー"
  },
  "link_7262adec": {
    "message": "リンク"
  },
  "link_options_a16b758b": {
    "message": "リンクオプション"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "リンクタイプ：{ linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "{ start } で始まるテキストとのリンク"
  },
  "links_14b70841": {
    "message": "リンク"
  },
  "links_to_an_external_site_de74145d": {
    "message": "外部サイトにリンクしています。"
  },
  "lists_cd1336fc": {
    "message": "リスト"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "リストはリスト形式にしなければなりません。"
  },
  "load_more_35d33c7": {
    "message": "もっと読み込む"
  },
  "loading_25990131": {
    "message": "読み込み中・・・"
  },
  "loading_bde52856": {
    "message": "読み込み中"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "クローズドキャプション/サブタイトルの読み込みに失敗しました。"
  },
  "loading_external_tool_d839042c": {
    "message": "外部ツールを読み込み中"
  },
  "loading_failed_b3524381": {
    "message": "読み込みに失敗しました..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "読込みに失敗しました。"
  },
  "loading_folders_d8b5869e": {
    "message": "フォルダを読み込み中..."
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "{ fileName }のプレースホルダを読み込み中。"
  },
  "loading_please_wait_d276220a": {
    "message": "読み込み中 - しばらくお待ちください"
  },
  "loading_preview_9f077aa1": {
    "message": "プレビュー読み込み中"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "速度を1倍速に固定する"
  },
  "locked_762f138b": {
    "message": "ロックされています"
  },
  "logical_equivalence_76fca396": {
    "message": "論理的等価性"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "論理的等価性 (短い)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "論理的等価性 (短・太)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "論理的等価（厚み）"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "低い水平ドット"
  },
  "magenta_4a65993c": {
    "message": "マジェンタ"
  },
  "maps_to_e5ef7382": {
    "message": "マッピング先："
  },
  "math_icon_ad4e9d03": {
    "message": "数学のアイコン"
  },
  "media_af190855": {
    "message": "メディア"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "メディアファイルは処理中です。後ほどもう一度やり直してください。"
  },
  "media_options_saved_560c4ec8": {
    "message": "メディアオプションが保存されました。"
  },
  "media_title_2112243b": {
    "message": "メディアタイトル"
  },
  "medium_5a8e9ead": {
    "message": "中"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "中 ({ width } x { height }px)"
  },
  "merge_links_2478df96": {
    "message": "リンクをマージする"
  },
  "mic_a7f3d311": {
    "message": "マイク"
  },
  "microphone_disabled_15c83130": {
    "message": "マイク無効"
  },
  "middle_27dc1d5": {
    "message": "中位"
  },
  "minimize_file_preview_da911944": {
    "message": "ファイル プレビューを最小化"
  },
  "minimize_video_20aa554b": {
    "message": "ビデオを最小化"
  },
  "minus_fd961e2e": {
    "message": "マイナス"
  },
  "minus_plus_3461f637": {
    "message": "マイナス/プラス"
  },
  "misc_3b692ea7": {
    "message": "その他"
  },
  "miscellaneous_e9818229": {
    "message": "その他"
  },
  "module_90d9fd32": {
    "message": "モジュール"
  },
  "modules_c4325335": {
    "message": "モジュール"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "{ directionWord }トリミングに画像を移動中。"
  },
  "mu_37223b8b": {
    "message": "ミュー"
  },
  "multi_color_image_63d7372f": {
    "message": "マルチカラー画像"
  },
  "multiplication_sign_15f95c22": {
    "message": "乗算記号"
  },
  "music_icon_4db5c972": {
    "message": "音楽のアイコン"
  },
  "my_files_2f621040": {
    "message": "マイ ファイル"
  },
  "n_th_root_9991a6e4": {
    "message": "N番目のルート"
  },
  "nabla_1e216d25": {
    "message": "ナブラ"
  },
  "name_1aed4a1b": {
    "message": "名前"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "ナチュラル (音楽)"
  },
  "natural_numbers_3da07060": {
    "message": "自然数"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "メニューまたはツールバーを移動する"
  },
  "navigation_ee9af92d": {
    "message": "ナビゲーション"
  },
  "nested_greater_than_d852e60d": {
    "message": "ネストされた＞"
  },
  "nested_less_than_27d17e58": {
    "message": "ネストされた＜"
  },
  "new_quiz_34aacba6": {
    "message": "新しい小テスト"
  },
  "next_40e12421": {
    "message": "次へ"
  },
  "next_findtext_9d69f0fe": {
    "message": "次{ findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "アクセシビリティの問題は検出されませんでした。"
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "アナウンスはまだ作成されていません。"
  },
  "no_announcements_found_20185afc": {
    "message": "アナウンスが見つかりません。"
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "課題はまだ作成されていません。"
  },
  "no_assignments_found_79e46d7f": {
    "message": "課題が見つかりません。"
  },
  "no_changes_to_save_d29f6e91": {
    "message": "保存する変更はありません。"
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "ディスカッションはまだ作成されていません。"
  },
  "no_discussions_found_9284063b": {
    "message": "ディスカッションが見つかりません。"
  },
  "no_e16d9132": {
    "message": "いいえ"
  },
  "no_file_chosen_9a880793": {
    "message": "ファイルが選択されていません"
  },
  "no_headers_9bc7dc7f": {
    "message": "ヘッダーなし"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "モジュールはまだ作成されていません。"
  },
  "no_modules_found_2df43a40": {
    "message": "モジュールが見つかりません。"
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "ページはまだ作成されていません。"
  },
  "no_pages_found_6799350": {
    "message": "ページが見つかりません。"
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "このファイルでは、プレビューは利用できません。"
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "小テストはまだ作成されていません。"
  },
  "no_quizzes_found_c80c537a": {
    "message": "小テストが見つかりません。"
  },
  "no_results_940393cf": {
    "message": "結果がありません。"
  },
  "no_results_found_58717065": {
    "message": "結果が見つかりませんでした"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "{ filterTerm }の結果が見つかりませんでした"
  },
  "no_video_1ed00b26": {
    "message": "ビデオなし"
  },
  "none_3b5e34d2": {
    "message": "なし"
  },
  "none_selected_b93d56d2": {
    "message": "選択されたものなし"
  },
  "normal_text_7b03da48": {
    "message": "通常のテキスト"
  },
  "not_equal_6e2980e6": {
    "message": "≠"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "（）にはない（の要素ではない）"
  },
  "not_negation_1418ebb8": {
    "message": "ない (否定)"
  },
  "not_subset_dc2b5e84": {
    "message": "部分集合ではない"
  },
  "not_subset_strict_23d282bf": {
    "message": "部分集合ではない（厳格）"
  },
  "not_superset_5556b913": {
    "message": "上位集合ではない"
  },
  "not_superset_strict_24e06f36": {
    "message": "上位集合ではない（厳格）"
  },
  "nu_1c0f6848": {
    "message": "ニュー"
  },
  "octagon_e48be9f": {
    "message": "八角形"
  },
  "olive_6a3e4d6b": {
    "message": "オリーブ"
  },
  "omega_8f2c3463": {
    "message": "オメガ"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "アイコンを保存するには、以下のいずれかのスタイルを追加する必要があります：アイコンの色、輪郭サイズ、アイコンのテキスト、画像"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "1つまたは複数のファイルの貼り付けに失敗しました。ファイルのアップロードまたはドラッグ＆ドロップを試してみてください。"
  },
  "open_circle_e9bd069": {
    "message": "オープンサークル"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "このキーボードショートカットダイアログを開く"
  },
  "open_title_application_fd624fc5": {
    "message": "{ title }アプリケーションを開く"
  },
  "operators_a2ef9a93": {
    "message": "演算子"
  },
  "options_3ab0ea65": {
    "message": "オプション"
  },
  "or_9b70ccaa": {
    "message": "または"
  },
  "orange_81386a62": {
    "message": "オレンジ"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "番号付きリストと番号無しリスト"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "他のエディタショートカットは下記をご覧ください"
  },
  "outline_color_3ef2cea7": {
    "message": "輪郭の色"
  },
  "outline_size_a6059a21": {
    "message": "外形寸法"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p }は有効なプロトコルではありません。"
  },
  "page_50c4823d": {
    "message": "ページ"
  },
  "pages_e5414c2c": {
    "message": "ページ"
  },
  "paragraph_5e5ad8eb": {
    "message": "段落"
  },
  "paragraph_applied_959b3fe5": {
    "message": "段落を適用した"
  },
  "paragraph_removed_d09320e": {
    "message": "段落を削除した"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "{ start } で始まる段落"
  },
  "parallel_d55d6e38": {
    "message": "並列"
  },
  "partial_derivative_4a9159df": {
    "message": "部分(微分)"
  },
  "pass_1c19a2b3": {
    "message": "合格"
  },
  "paste_5963d1c1": {
    "message": "貼り付け"
  },
  "pause_12af3bb4": {
    "message": "一時停止"
  },
  "pentagon_17d82ea3": {
    "message": "ペンタゴン"
  },
  "people_b4ebb13c": {
    "message": "メンバー"
  },
  "percentage_34ab7c2c": {
    "message": "割合"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "パーセンテージは数字でなければなりません"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "パーセンテージは{ percentage }%以上でなければなりません"
  },
  "performing_arts_icon_f3497486": {
    "message": "パフォーミングアーツのアイコン"
  },
  "perpendicular_7c48ede4": {
    "message": "垂直"
  },
  "phi_4ac33b6d": {
    "message": "ファイ"
  },
  "phi_variant_c9bb3ac5": {
    "message": "ファイ(変形)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "体育のアイコン"
  },
  "pi_dc4f0bd8": {
    "message": "パイ"
  },
  "pi_variant_10f5f520": {
    "message": "パイ(変形)"
  },
  "pick_a_color_557abfb0": {
    "message": "色を選択する"
  },
  "pink_68ad45cb": {
    "message": "ピンク"
  },
  "pixels_52ece7d1": {
    "message": "ピクセル"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "ピクセルは{ width } x { height }ピクセル以上でなければなりません。"
  },
  "play_1a47eaa7": {
    "message": "再生"
  },
  "play_media_comment_35257210": {
    "message": "メディア コメントの再生。"
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "{ name }まで{ createdAt }からのメディアのコメントを再生します。"
  },
  "player_layout_14e09a29": {
    "message": "プレーヤーレイアウト"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Canvas があなたのマイクとウェブカメラにアクセスできるようにしてください。"
  },
  "please_choose_a_file_c2449cc": {
    "message": "ファイルを選択してください"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "ファイル名を入力してください"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "サポートされているプラットフォームから有効な動画URLを入力してください。"
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "サポートされているタイプのファイルを選択してください"
  },
  "plus_d43cd4ec": {
    "message": "プラス"
  },
  "plus_minus_f8be2e83": {
    "message": "プラス/マイナス"
  },
  "posted_when_a578f5ab": {
    "message": "投稿済み:{ when }"
  },
  "power_set_4f26f316": {
    "message": "パワーセット"
  },
  "precedes_196b9aef": {
    "message": "優先・先導する"
  },
  "precedes_equal_20701e84": {
    "message": "優先・同等"
  },
  "preformatted_d0670862": {
    "message": "フォーマット済み"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "前へ"
  },
  "preview_53003fd2": {
    "message": "プレビュー"
  },
  "preview_a3f8f854": {
    "message": "プレビュー"
  },
  "preview_in_overlay_ed772c46": {
    "message": "オーバーレイでのプレビュー"
  },
  "preview_inline_9787330": {
    "message": "インラインでのプレビュー"
  },
  "previous_bd2ac015": {
    "message": "前"
  },
  "previous_findtext_8dfbfd30": {
    "message": "前{ findText }"
  },
  "previously_chosen_colors_f1338315": {
    "message": "以前に選択した色"
  },
  "prime_917ea60e": {
    "message": "素数"
  },
  "prime_numbers_13464f61": {
    "message": "素数"
  },
  "product_39cf144f": {
    "message": "積"
  },
  "proportional_f02800cc": {
    "message": "比例"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "プロトコルは、ftp、http、https、mailto、skype、telであるか、省略可能です"
  },
  "psi_e3f5f0f7": {
    "message": "プシー"
  },
  "published_c944a23d": {
    "message": "公開済み"
  },
  "published_when_302d8e23": {
    "message": "公開済み:{ when }"
  },
  "pumpkin_904428d5": {
    "message": "かぼちゃ"
  },
  "purple_7678a9fc": {
    "message": "パープル"
  },
  "quaternions_877024e0": {
    "message": "四元数"
  },
  "quiz_e0dcce8f": {
    "message": "小テスト"
  },
  "quizzes_7e598f57": {
    "message": "小テスト"
  },
  "rational_numbers_80ddaa4a": {
    "message": "有理数"
  },
  "real_numbers_7c99df94": {
    "message": "実数"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "（複素数の）実数部分"
  },
  "record_7c9448b": {
    "message": "記録"
  },
  "record_upload_media_5fdce166": {
    "message": "メディアの記録/アップロード"
  },
  "recording_98da6bda": {
    "message": "記録"
  },
  "red_8258edf3": {
    "message": "レッド"
  },
  "relationships_6602af70": {
    "message": "関係"
  },
  "religion_icon_246e0be1": {
    "message": "宗教学のアイコン"
  },
  "remove_f47dc62a": {
    "message": "削除"
  },
  "remove_filename_3ea029f6": {
    "message": "{ filename }を削除する"
  },
  "remove_heading_style_5fdc8855": {
    "message": "見出しスタイルを削除する"
  },
  "remove_link_d1f2f4d0": {
    "message": "リンクの削除"
  },
  "replace_all_d3d68b3": {
    "message": "すべて置換する"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "すべての{ findText }を{ replaceText }に置き換える"
  },
  "replace_e61834a7": {
    "message": "置換"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "{ findText }を{ replaceText }に置き換える"
  },
  "replace_with_eeff01ad": {
    "message": "（）と置換する"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "{ alertFindText }を{ alertReplaceText }に置き換えた"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "すべての{ alertFindText }を{ alertReplaceText }に置き換えた"
  },
  "reset_95a81614": {
    "message": "リセット"
  },
  "resize_ec83d538": {
    "message": "サイズ変更"
  },
  "restore_auto_save_deccd84b": {
    "message": "自動保存したものを復元しますか？"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "{ index } / { max }の結果。"
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "逆向きの回転式改札(イールドなし)"
  },
  "rho_a0244a36": {
    "message": "ロー"
  },
  "rho_variant_415245cd": {
    "message": "ロー (変種)"
  },
  "rich_content_editor_2708ef21": {
    "message": "リッチ コンテンツ エディタ"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "リッチテキストエリア{ OSKey }+F8 を押すとリッチコンテンツエディタにショートカットできます。"
  },
  "right_71ffdc4d": {
    "message": "右"
  },
  "right_align_39e7a32a": {
    "message": "右揃え"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "直角ブラケット"
  },
  "right_arrow_35e0eddf": {
    "message": "右の矢印"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "右矢印フック付き"
  },
  "right_ceiling_839dc744": {
    "message": "右シーリング"
  },
  "right_curly_brace_5159d5cd": {
    "message": "右波括弧"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "右下向き銛型矢印"
  },
  "right_floor_5392d5cf": {
    "message": "右床"
  },
  "right_to_left_9cfb092a": {
    "message": "右から左"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "右上向き銛型矢印"
  },
  "rightward_arrow_32932107": {
    "message": "右向き矢印"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "右が尖った三角形"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "画像を90度回転させる"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "画像を90度回転させる"
  },
  "rotation_9699c538": {
    "message": "回転"
  },
  "row_fc0944a7": {
    "message": "列"
  },
  "row_group_979f5528": {
    "message": "列グループ"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "残念ながら、pretty HTMLエディタはキーボードからはアクセスできません。生のHTMLエディタにはこちらからアクセスできます。"
  },
  "save_11a80ec3": {
    "message": "保存"
  },
  "save_copy_ca63944e": {
    "message": "コピーを保存する"
  },
  "save_media_cb9e786e": {
    "message": "メディアを保存する"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "保存したアイコンメーカーのアイコン"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "スクリーンリーダーは、代替テキストなしでは画像に表示される内容を判別することはできません。また、ファイル名は、しばいば文脈や意味を記述しない無意味な数字や文字列であることがあります。"
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "スクリーンリーダーは、画像の内容と意味を説明する代替テキストなしでは画像に表示される内容を判別することはできません。代替テキストは簡潔かつ簡潔でなければなりません。"
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "スクリーンリーダーは、画像の内容と意味を説明する代替テキストなしでは画像に表示される内容を判別することはできません。"
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "スクリーンリーダーは、適切な構造なしでは表を解釈できません。表のヘッダーは、方向と内容の範囲を提供します。"
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "スクリーンリーダーは、適切な構造なしでは表を解釈できません。表のキャプションは、表の文脈と一般的な理解を記述するものです。"
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "スクリーンリーダーは、適切な構造なしでは表を解釈できません。表のヘッダーは、コンテンツの方向と概要を提供します。"
  },
  "script_l_42a7b254": {
    "message": "スクリプト L"
  },
  "search_280d00bd": {
    "message": "検索"
  },
  "select_audio_source_21043cd5": {
    "message": "音声源を選択"
  },
  "select_crop_shape_d441feeb": {
    "message": "クロップ形状の選択"
  },
  "select_language_7c93a900": {
    "message": "言語を選択する"
  },
  "select_video_source_1b5c9dbe": {
    "message": "ビデオ源を選択"
  },
  "selected_274ce24f": {
    "message": "選択されました"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "選択された{ linkFileName }"
  },
  "selection_b52c4c5e": {
    "message": "選択"
  },
  "set_header_scope_8c548f40": {
    "message": "ヘッダースコープを設定する"
  },
  "set_minus_b46e9b88": {
    "message": "マイナス設定"
  },
  "set_table_header_cfab13a0": {
    "message": "表のヘッダーを設定する"
  },
  "sharp_music_ab956814": {
    "message": "シャープ (音楽)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+矢印"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Shift-Oでpretty HTMLエディタを開きます。"
  },
  "shortcut_911d6255": {
    "message": "ショートカット"
  },
  "show_image_options_1e2ecc6b": {
    "message": "画像オプションを表示"
  },
  "show_link_options_545338fd": {
    "message": "リンクオプションを表示する"
  },
  "show_rolling_transcript_c1481744": {
    "message": "ロール字幕を表示する"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "ロール字幕を表示"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "視認ユーザーは大きく太字の見出しを探し、Webページをすばやく参照します。スクリーンリーダーのユーザーは、文脈に基づいた理解を行う際にヘッダーに依存しています。ヘッダーは適切な構造を使用しなければなりません。"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "視認ユーザーは大きく太字の見出しを探し、Webページをすばやく参照します。スクリーンリーダーのユーザーは、文脈に基づいた理解を行う際にヘッダーに依存しています。ヘッダーは適切な構造内で簡潔でなければなりません。"
  },
  "sigma_5c35e553": {
    "message": "シグマ"
  },
  "sigma_variant_8155625": {
    "message": "シグマ (バリエーション)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "単色画像"
  },
  "single_color_image_color_95fa9a87": {
    "message": "単色画像の色"
  },
  "size_b30e1077": {
    "message": "サイズ"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "キャプションファイルのサイズが最大 { max } kb の許容ファイルサイズを超えている。"
  },
  "small_b070434a": {
    "message": "小"
  },
  "small_width_x_height_px_359acd38": {
    "message": "小 ({ width } x { height }px)"
  },
  "solid_circle_9f061dfc": {
    "message": "一色の円"
  },
  "something_went_wrong_89195131": {
    "message": "問題が発生しました。"
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "ウェブカムにアクセス中にエラーが生じました。"
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "何かがうまくいきませんでした。何を見せればいいのかわかりません。"
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "問題が発生しました。接続を確認し、ページを再読み込みして、もう一度やり直してください。"
  },
  "something_went_wrong_d238c551": {
    "message": "なにかが失敗しました"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "画面の共有中に問題が発生しました。"
  },
  "sort_by_e75f9e3e": {
    "message": "分類する"
  },
  "spades_suit_b37020c2": {
    "message": "スペード (1組)"
  },
  "square_511eb3b3": {
    "message": "四角"
  },
  "square_cap_9ec88646": {
    "message": "四角い帽子"
  },
  "square_cup_b0665113": {
    "message": "四角い帽子"
  },
  "square_root_e8bcbc60": {
    "message": "平方根"
  },
  "square_root_symbol_d0898a53": {
    "message": "平方根記号"
  },
  "square_subset_17be67cb": {
    "message": "正方形部分集合"
  },
  "square_subset_strict_7044e84f": {
    "message": "正方形部分集合 (厳密)"
  },
  "square_superset_3be8dae1": {
    "message": "正方形上位集合"
  },
  "square_superset_strict_fa4262e4": {
    "message": "正方形部分集合 (厳密)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "四角い番号無しリスト"
  },
  "star_8d156e09": {
    "message": "スター"
  },
  "start_over_f7552aa9": {
    "message": "最初からやり直し"
  },
  "start_recording_9a65141a": {
    "message": "録画開始"
  },
  "steel_blue_14296f08": {
    "message": "スチールブルー"
  },
  "studio_media_options_ee504361": {
    "message": "スタジオメディアオプション"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Studio メディア オプショントレイ"
  },
  "styles_2aa721ef": {
    "message": "スタイル"
  },
  "submit_a3cc6859": {
    "message": "提出"
  },
  "submitting_b90fac62": {
    "message": "提出中..."
  },
  "subscript_59744f96": {
    "message": "下付き"
  },
  "subset_19c1a92f": {
    "message": "部分集合"
  },
  "subset_strict_8d8948d6": {
    "message": "部分集合 (厳密)"
  },
  "succeeds_9cc31be9": {
    "message": "成功"
  },
  "succeeds_equal_158e8c3a": {
    "message": "成功イコール"
  },
  "sum_b0842d31": {
    "message": "合計"
  },
  "superscript_8cb349a2": {
    "message": "上付き"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "上付き文字と下付き文字"
  },
  "superset_c4db8a7a": {
    "message": "部分集合"
  },
  "superset_strict_c77dd6d2": {
    "message": "部分集合 (厳密)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "サポートされるファイルタイプ：SRT または WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "「可愛い」htmlエディタに切り替える"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "「生の」htmlエディタに切り替える"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "htmlエディタに切り替える"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "リッチテキストエディタに切り替える"
  },
  "syllabus_f191f65b": {
    "message": "シラバス"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "システムオーディオを許可"
  },
  "system_audio_disabled_c177bd13": {
    "message": "システムオーディオが無効"
  },
  "tab_arrows_4cf5abfc": {
    "message": "TAB/矢印"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "{ start } で始まる表ヘッダー"
  },
  "table_starting_with_start_e7232848": {
    "message": "{ start } で始まる表"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "表のヘッダーは範囲を指定しなければなりません。"
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "表には、表の内容を説明するキャプションが含まれていなければなりません。"
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "表には、少なくとも1つのヘッダーが含まれていなければなりません。"
  },
  "tau_880974b7": {
    "message": "タウ"
  },
  "teal_f729a294": {
    "message": "ティール"
  },
  "text_7f4593da": {
    "message": "テキスト"
  },
  "text_background_color_16e61c3f": {
    "message": "テキスト背景の色"
  },
  "text_color_acf75eb6": {
    "message": "テキストカラー"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "テキストは、テキストと背景との間に十分なコントラストがなければ、特に視力の弱い人にとっては読みにくくなります。"
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "18pt（または太字14pt）より大きいテキストは、3：1の最小コントラスト比で表示しなければなりません。"
  },
  "text_optional_384f94f7": {
    "message": "テキスト (オプション)"
  },
  "text_position_8df8c162": {
    "message": "テキストの位置"
  },
  "text_size_887c2f6": {
    "message": "テキストのサイズ"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "18pt（または太字14pt）より小きいテキストは、4.5：1の最小コントラスト比で表示しなければなりません。"
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "文書のプレビューは現在処理中です。後ほどもう一度やり直してください。"
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "ページの最初のヘッダーはH2であるべきです。"
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "リッチコンテンツ領域の高さが縮小されました。"
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "リッチコンテンツ領域の高さが拡大されました。"
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "この資料はパブリック ドメインです"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "この資料はクリエイティブ コモンズ ライセンスの対象となります"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "素材には例外があります。例：公正使用、引用権、または適用される著作権法に基づくその他"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "pretty HTMLエディタはキーボードからはアクセスできません。ShiftOを押してpretty HTMLエディタを開きます。"
  },
  "therefore_d860e024": {
    "message": "したがって"
  },
  "theta_ce2d2350": {
    "message": "シータ"
  },
  "theta_variant_fff6da6f": {
    "message": "シータ （厳格）"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "下向きの太い矢印"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "左の太い矢印"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "左向きの太い矢印"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "下向きの太い矢印"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "右向きの太い矢印"
  },
  "thick_upward_arrow_acd20328": {
    "message": "上向きの太い矢印"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "この文書は Canvas 内で表示できません。"
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "この方程式は基本ビューでは描画できません。"
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "この画像は現在利用できません"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "この動画にはYouTubeの広告が表示される場合があります。"
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "あなたのビデオのブラウザ内のタイトルは正しいものですが、データベース内でそれを更新できませんでした。"
  },
  "thumbnail_e0de666f": {
    "message": "サムネイル"
  },
  "timebar_a4d18443": {
    "message": "タイムバー"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "タイトルを空にすることはできません"
  },
  "title_ee03d132": {
    "message": "タイトル"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "投稿するには:{ when }"
  },
  "to_do_when_2783d78f": {
    "message": "タスク：{ when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "{ summary }グループを切り替える"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "ツールチップを切り替える"
  },
  "tools_2fcf772e": {
    "message": "ツール"
  },
  "top_66e0adb6": {
    "message": "上"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "字幕パネルは幅720px以上で使用可能です。"
  },
  "tray_839df38a": {
    "message": "トレイ"
  },
  "triangle_6072304e": {
    "message": "三角形"
  },
  "turnstile_yields_f9e76df1": {
    "message": "回転式改札(イールド)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "Ctrl F9 と入力して、画像オプションにアクセスします。{ text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "Ctrl F9 と入力して、リンクオプションにアクセスします。{ text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "Ctrl F9 と入力して、テーブルオプションにアクセスします。{ text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "リソースURL選択を決定するために利用可能"
  },
  "underline_applied_ae01ec97": {
    "message": "下線を適用した"
  },
  "underline_removed_3693e17c": {
    "message": "下線を削除した"
  },
  "union_e6b57a53": {
    "message": "ユニオン"
  },
  "unpublished_dfd8801": {
    "message": "非公開"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "保存されていない変更内容は失われます"
  },
  "untitled_16aa4f2b": {
    "message": "無題"
  },
  "untitled_efdc2d7d": {
    "message": "無題"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "上・左斜め矢印"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "上・右の対角線矢印"
  },
  "up_c553575d": {
    "message": "上"
  },
  "updated_link_a827e441": {
    "message": "アップデートされたリンク"
  },
  "upload_document_253f0478": {
    "message": "ドキュメントをアップロードする"
  },
  "upload_file_fd2361b8": {
    "message": "ファイルアップロード"
  },
  "upload_image_6120b609": {
    "message": "イメージのアップロード"
  },
  "upload_media_ce31135a": {
    "message": "メディアを読み込む"
  },
  "upload_record_media_e4207d72": {
    "message": "メディアをアップロード/記録する"
  },
  "uploading_19e8a4e7": {
    "message": "アップロードしています"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "大文字のアルファベット順リスト"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "大文字のデルタ"
  },
  "uppercase_gamma_86f492e9": {
    "message": "大文字のガンマ"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "大文字のラムダ"
  },
  "uppercase_omega_8aedfa2": {
    "message": "大文字のオメガ"
  },
  "uppercase_phi_caa36724": {
    "message": "大文字のファイ"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "大文字のパイ"
  },
  "uppercase_psi_6395acbe": {
    "message": "大文字のプシー"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "大文字のローマ数字順リスト"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "大文字のシグマ"
  },
  "uppercase_theta_49afc891": {
    "message": "大文字のシータ"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "大文字のユプシロン"
  },
  "uppercase_xi_341e8556": {
    "message": "大文字のクシー"
  },
  "upsilon_33651634": {
    "message": "ユプシロン"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "上と下を指す尖った矢印"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "上と下を指す尖った矢印(太い)"
  },
  "upward_arrow_9992cb2d": {
    "message": "上向き矢印"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "上が尖った三角形"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "使用権:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "使用権:（必須）"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "矢印キーを使用してオプションを移動します。"
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "矢印キーで図形を選択します。"
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "矢印キーを使ってサイズを選択します。"
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "矢印キーを使ってテキストの位置を選択します。"
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "矢印キーを使ってテキストのサイズを選択します。"
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "矢印キーを使ってアウトラインサイズを選択します。"
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "スクリーンリーダーで使用される{ TYPE }"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "読み上げ機能で使用される代替テキスト"
  },
  "user_documents_c206e61f": {
    "message": "ユーザードキュメント"
  },
  "user_files_78e21703": {
    "message": "ユーザーファイル"
  },
  "user_images_b6490852": {
    "message": "ユーザー画像"
  },
  "user_media_14fbf656": {
    "message": "ユーザーメディア"
  },
  "vector_notation_cf6086ab": {
    "message": "ベクトル (表記法)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "垂直のバー（ビルダー表記法を設定）"
  },
  "vertical_dots_bfb21f14": {
    "message": "垂直の点"
  },
  "video_options_24ef6e5d": {
    "message": "ビデオオプション"
  },
  "video_options_tray_3b9809a5": {
    "message": "ビデオオプショントレイ"
  },
  "video_player_b371005": {
    "message": "ビデオプレーヤー"
  },
  "video_player_for_9e7d373b": {
    "message": "（）のビデオプレーヤー "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "{ title }のビデオプレーヤー"
  },
  "video_url_889d3263": {
    "message": "動画 URL"
  },
  "view_all_e13bf0a6": {
    "message": "すべてを表示する"
  },
  "view_ba339f93": {
    "message": "表示"
  },
  "view_description_30446afc": {
    "message": "説明の表示"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "キーボードのショートカットを見る"
  },
  "view_title_description_67940918": {
    "message": "{ title }説明の表示"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "語数・文字数を表示"
  },
  "viewer_restrictions_e14274c9": {
    "message": "ビューアーの制限"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "デバイスに接続されているオンになっているマイクを検出できませんでした。"
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "デバイスに接続されているオンになっているウェブカメラを検出できませんでした。"
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "デバイスに接続されているオンになっているウェブカメラやマイクを検出できませんでした。"
  },
  "webcam_disabled_30c66986": {
    "message": "ウェブカメラが無効"
  },
  "webcam_fe91b20f": {
    "message": "ウェブカム"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "ウェブページのH1は1つだけであるべきで、これはページのタイトルに自動的に使用されます。コンテンツの最初のヘッダーはH2であるべきです。"
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "アイテムをリスト形式に視覚的にフォーマットするマークアップが使用されますが、リストの関係を示唆するものではなく、ユーザが情報をナビゲートするのは難しいかもしれません。"
  },
  "white_87fa64fd": {
    "message": "ホワイト"
  },
  "why_523b3d8c": {
    "message": "理由"
  },
  "width_492fec76": {
    "message": "幅"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "幅と高さは数字でなければなりません"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height }px"
  },
  "wiki_home_9cd54d0": {
    "message": "Wiki ホーム"
  },
  "word_count_c77fe3a6": {
    "message": "語数"
  },
  "words_b448b7d5": {
    "message": "語"
  },
  "wreath_product_200b38ef": {
    "message": "花輪製品"
  },
  "xi_149681d0": {
    "message": "クシー"
  },
  "yes_dde87d5": {
    "message": "はい"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "現在カラーパレット上にいます。パレット上で上、左、下、右に移動するには、それぞれ「W」、「A」、「S」、「D」ボタンを使用します"
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "現在カラースライダーの上にいます。スライダー上で左または右に移動するには、それぞれ「A」と「D」ボタンを使用します"
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "現在アルファスライダーにいます。スライダー上で左または右に移動するには、それぞれ「A」と「D」ボタンを使用します"
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "Icon Makerトレイに未保存の変更があります。これらの変更を保存せずに続行しますか？"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "ページの階層を維持するために、追加のヘッダーを調整する必要がある場合があります。"
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "空のファイルをアップロードすることはできません。"
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "あなたの画像はIcon Maker用に圧縮されています。{ size }KB未満の画像は圧縮されません。"
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "ブラウザの設定でマイクがブロックされています。"
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "ブラウザの設定でウェブカメラとマイクがブロックされています。"
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "ブラウザの設定でウェブカメラがブロックされています。"
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "あなたのウェブカメラは既に使用中かもしれません。"
  },
  "youtube_embed_url_5c1018d4": {
    "message": "YouTube埋め込みURL"
  },
  "zeta_5ef24f0e": {
    "message": "ゼータ"
  },
  "zoom_f3e54d69": {
    "message": "Zoom"
  },
  "zoom_in_image_bb97d4f": {
    "message": "画像を拡大する"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "画像を縮小する"
  }
};
formatMessage.addLocale({
  ja: locale
});